import React from 'react'
import { Widget } from 'features/types'
import UnexpectedErrorBoundary from 'components/UnexpectedErrorBoundary'
import PreSearchDataGuards from 'components/widget/LanguageWidgets/share/guards/PreSearchDataGuards'
import PostSearchDataGuards from 'components/widget/LanguageWidgets/share/guards/PostSearchDataGuards'
import Table from '../share/Table'
import RunSearchEffect from '../share/RunSearchEffect'

const SocialWebLanguageWidget: Widget = ({ widgetId }) => (
  <UnexpectedErrorBoundary>
    <PreSearchDataGuards widgetId={widgetId}>
      <RunSearchEffect widgetId={widgetId}>
        <PostSearchDataGuards widgetId={widgetId}>
          <Table widgetId={widgetId} />
        </PostSearchDataGuards>
      </RunSearchEffect>
    </PreSearchDataGuards>
  </UnexpectedErrorBoundary>
)

export default SocialWebLanguageWidget
